<template>
  <div id="app">
    <!--<headers></headers>-->
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'Vuex'

export default {
  name: 'App',
  data () {
    return {
      transitionName: ''
    }
  },
  created () {
    this.reload() // 如果访问页面不存在，则重定向到Index和pwaIndex
  },
  watch: {
    $route () {
      this.reload() // 如果访问页面不存在，则重定向到Index和pwaIndex
    },
    '$route' (to, from) {
      const list = ['Index', 'oldVersionList', 'oldVersionInfo']
      const toName = to.name
      const fromName = from.name
      const toIndex = list.indexOf(toName)
      const fromIndex = list.indexOf(fromName)
      this.transitionName = 'slide-left'

      if(toName === null || fromName === null || toName === fromName) {
        this.transitionName = 'fade'
      } else {
        if(toIndex > -1 && fromIndex > -1) {
          if(toIndex < fromIndex) {
            this.transitionName = 'slide-right'
          }
        }
      }
    }
  },
  mounted () {},
  computed: {
    ...mapGetters({
      'token': 'token'
    })
  },
  methods: {
    ...mapMutations(['']),
    ...mapActions(['']),
    setManifest (res, pwaConfigurationItem) { // 动态插入head数据及pwa数据
      if (res.status === 200 && res.data.head.errCode === '0000') {
        const { in_icon, out_name, out_keyword } = res.data.body.data
        const start_url = location.href + '&isPwa=1'
        const myManifestData = {
          'name': pwaConfigurationItem ? pwaConfigurationItem.displayName : out_name,
          'short_name': pwaConfigurationItem ? pwaConfigurationItem.displayName : out_name,
          'description': out_keyword,
          'start_url': start_url,
          'display': 'standalone',
          'theme_color': '#2696f3',
          'background_color': '#2696f3',
          'icons': pwaConfigurationItem ? pwaConfigurationItem.displayIcon : in_icon
        }
        const stringManifest = JSON.stringify(myManifestData)
        const blob = new Blob([stringManifest], {type: 'application/json'})
        const manifestURL = URL.createObjectURL(blob)
        document.querySelector('#myPwaAppTitle').setAttribute('content', out_name) // 动态插入content
        document.querySelector('#myPwaAppleIcon').setAttribute('href', in_icon) // 动态插入苹果icon
        document.querySelector('#myTitle').innerText = out_name // 动态插入标题
        document.querySelector('#myPwaManifest').setAttribute('href', manifestURL) // 动态插入manifest数据
      }
    },
    onSuccessCopyRandomCode (text) { // 复制UDID到剪切板成功
      alert('复制成功')
    },
    onErrorCopyRandomCode (text) { // 复制UDID到剪切板失败
      alert('复制失败，请截屏或手动复制')
    },
    reload () { // 如果访问页面不存在，则重定向到Index和pwaIndex
      if (this.$route.fullPath !== '/') { // 不知道为嘛初次进来时fullPath会为/
        this.$route.matched.length || this.$router.push({path: this.$route.path.slice(0, 4) === '/pwa' ? '/pwaIndex' : '/Index', query: this.$route.query}) // 如果当前路由没有，则重定向到/Index模块，并将query参数带过去
      }
    }
  },
  components: {
  //  'headers': () => import('./components/Header/headers.vue'),
  }
}
</script>

<style>
body{-webkit-user-select: none;user-select: none; -moz-user-select: none;-ms-user-select: none;font-family: -apple-system;}
</style>



// WEBPACK FOOTER //
// src/App.vue